import { render } from "./Blog.vue?vue&type=template&id=f2d5cea4"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"
script.render = render

export default script